/* eslint-disable react-refresh/only-export-components */

import { createBrowserRouter, createHashRouter } from "react-router-dom";
import { Suspense, lazy } from "react"; // 引用路由懒加载方法和组件
import LayoutProvider from "../page/LayoutProvider";
import ErrorPage from "../page/ErrorPage";
import TabBar from "../page/TabBar";
// const TabBar = lazy(() => import("../page/TabBar"));
// import Login from "../page/Login";
const Login = lazy(() => import("../page/Login"));
// import SessionChat from "../page/SessionChat";
const SessionChat = lazy(() => import("../page/SessionChat"));
// import Home from "../components/Home";
const Home = lazy(() => import("../components/Home"));
// import Apps from "../components/Apps";
const Apps = lazy(() => import("../components/Apps"));
// import Explore from "../components/Explore";
const Explore = lazy(() => import("../components/Explore"));
// import Me from "../components/Me";
const Me = lazy(() => import("../components/Me"));
// import Settings from "../page/Settings";
const Settings = lazy(() => import("../page/Settings"));
const Welcome = lazy(() => import("../page/Welcome"));

// import Skeleton from "@mui/material/Skeleton";

const RouteLoading = () => {
  return (
    <>
      {/* <Skeleton variant="rectangular" width={"100%"} height={"100%"} /> */}
      <div
        style={{
          width: "100%",
          height: "100%",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        加载中...
      </div>
    </>
  );
};

const router = createHashRouter([
  {
    path: "/",
    element: <LayoutProvider />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <TabBar />,
      },
      {
        path: "/apps",
        element: <TabBar />,
        children: [
          {
            index: true,
            // element: <Apps />,
            element: (
              <Suspense fallback={<RouteLoading />}>
                <Apps />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "/explore",
        element: <TabBar />,
        children: [
          {
            index: true,
            // element: <Explore />,
            element: (
              <Suspense fallback={<RouteLoading />}>
                <Explore />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "/me",
        element: <TabBar />,
        children: [
          {
            index: true,
            // element: <Me />,
            element: (
              <Suspense fallback={<RouteLoading />}>
                <Me />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "/login",
        // element: <Login />,
        element: (
          <Suspense fallback={<RouteLoading />}>
            <Login />
          </Suspense>
        ),
      },
      {
        path: "/s/:sessionId",
        // element: <SessionChat />,
        element: (
          <Suspense fallback={<RouteLoading />}>
            <SessionChat />
          </Suspense>
        ),
      },
      {
        path: "/settings",
        // element: <Settings />,
        element: (
          <Suspense fallback={<RouteLoading />}>
            <Settings />
          </Suspense>
        ),
      },
      {
        path: "/welcome",
        element: (
          <Suspense fallback={<RouteLoading />}>
            <Welcome />
          </Suspense>
        ),
      },
    ],
  },
]);

export default router;
